<template>
  <div>
    <div v-if="pko || pko != null" class="md-layout noprint ">
      <v-toolbar
        :src="require('@/assets/images/vuebackground.jpg')"
        style="transform: translateY(0)"
      >
        <v-spacer></v-spacer>
        <v-menu :close-on-content-click="false" open-on-hover bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              v-on="on"
            >
              <span style="color:white">Options</span>
            </v-btn>
          </template>
    
          <v-list>
            <v-list-item @click="active = true">
              <v-list-item-title>History Status</v-list-item-title>
            </v-list-item>
            <v-list-group
              v-if="pko.pko_status!=3 && pko.pko_status!=4 && pko.pko_status!=5 && pko.pko_status!=6 
              || pko.pko_status == 3 && check_object_value(me.role_name,'name',['Admin','Terminate PKO'])"
            >
              <template v-slot:activator>
                <v-list-item
                >
                  <v-list-item-title>Change Status</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item v-if="(pko.pko_status==0 || pko.pko_status==2) && role.requester" class="noprint" @click="updateStatusConfirmation(1,'Request Approval')"><v-list-item-title>Request Approval</v-list-item-title></v-list-item>
              <v-list-item v-if="pko.pko_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation(3, 'Approve')"><v-list-item-title>Approve</v-list-item-title></v-list-item>
              <v-list-item v-if="pko.pko_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation(2,'Reject', true)"><v-list-item-title>Reject</v-list-item-title></v-list-item>
              <v-list-item
                v-if="pko.pko_status == 3 && check_object_value(me.role_name,'name',['Admin','Terminate PKO'])"
                class="noprint"
                @click="updateStatusConfirmation(5, 'Terminate by Payment', true)"><v-list-item-title>Terminate by Payment</v-list-item-title></v-list-item
              >
            </v-list-group>
          </v-list>
        </v-menu>
        <!-- <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              text
              small
              v-if="pko.pko_status!=3 && pko.pko_status!=4 && pko.pko_status!=5 && pko.pko_status!=6 || pko.pko_status == 3 && check_object_value(me.role_name,'name',['Admin','Terminate PKO'])"
            >
              <span style="color:white;">Change Status</span>
            </v-btn>
            <v-btn
              small
              text
              @click="active = true"
            >
              <span style="color:white;">History Status</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="(pko.pko_status==0 || pko.pko_status==2) && role.requester" class="noprint" @click="updateStatusConfirmation(1,'Request Approval')">Request Approval</v-list-item>
            <v-list-item v-if="pko.pko_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation(3, 'Approve')">Approve</v-list-item>
            <v-list-item v-if="pko.pko_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation(2,'Reject', true)">Reject</v-list-item>
            <v-list-item
              v-if="pko.pko_status == 3 && check_object_value(me.role_name,'name',['Admin','Terminate PKO'])"
              class="noprint"
              @click="updateStatusConfirmation(5, 'Terminate by Payment', true)"
              >Terminate by Payment</v-list-item
            >
          </v-list>
        </v-menu> -->
        <v-btn icon @click="closeDetail()">
          <v-icon style="color:white;">mdi-export</v-icon>
        </v-btn>

        <template v-slot:extension>
            <v-toolbar-title style="color:white;">
              <p v-if="pko.pko_status==0" style="text-align: left; font-weight:bold;">REGISTERED</p>
              <p v-if="pko.pko_status==1" style="text-align: left; font-weight:bold;">WAITING APPROVAL</p>
              <p v-if="pko.pko_status==2" style="text-align: left; font-weight:bold;">REJECTED</p>
              <p v-if="pko.pko_status==3" style="text-align: left; font-weight:bold;">ACTIVE</p>
              <p v-if="pko.pko_status==4" style="text-align: left; font-weight:bold;">PAYMENT COMPLETED</p>
              <p v-if="pko.pko_status==5" style="text-align: left; font-weight:bold;">TERMINATED BY PAYMENT</p>
              <p v-if="pko.pko_status==5 && pko.pko_terminate_date!=null" style="text-align: left; font-weight:bold;">At {{ $moment(pko.pko_terminate_date).utc().format('DD-MM-YYYY') }}</p>
              <p v-if="pko.pko_status==6" style="text-align: left; font-weight:bold;">CHANGE TO OWNERSHIP</p>
            </v-toolbar-title>
        </template>
      </v-toolbar>

      <md-dialog  class="z-index "  :md-active.sync="active">
        <md-dialog-title>
          History Status
          <md-button style="float:right;" class="md-dense md-round md-icon-button" @click="active = false">
            <md-icon>close</md-icon>
          </md-button>
        </md-dialog-title>
        <md-card class="md-content1 md-scrollbar">
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head ><b>Change</b></md-table-head>
                <md-table-head ><b>By</b></md-table-head>
                <md-table-head ><b>Action</b></md-table-head>
                <md-table-head ><b>Status</b></md-table-head>
              </md-table-row>
              <md-table-row v-for="(item, index) in pko.pko_history_status" :key="index"> 
                <md-table-cell >{{$moment(item.updated_at).utc().format('DD-MM-YYYY HH:mm')}}</md-table-cell>
                <md-table-cell >{{item.name_by}}</md-table-cell>
                <md-table-cell >
                  <span v-if="item.status_action==1">Request Approval</span>
                  <span v-if="item.status_action==2">Approve</span>
                  <span v-if="item.status_action==3">Reject</span>
                  <span v-if="item.status_action==4">Payment Complete</span>
                  <span v-if="item.status_action==5">Terminated By Payment</span>
                  <span v-if="item.status_action==6">Change to Ownership</span>
                </md-table-cell>
                <md-table-cell >
                  <span v-if="item.status==0">Registered</span>
                  <span v-if="item.status==1">Waiting Approval</span>
                  <span v-if="item.status==2">Reject</span>
                  <span v-if="item.status==3">Active</span>
                  <span v-if="item.status==4">Payment Completed</span>
                  <span v-if="item.status==5">Terminate by Payment</span>
                  <span v-if="item.status==6">Change to Ownership</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </md-dialog>

      <!-- <md-toolbar class=" color " style="width:100%">
        <div style="width:50%">
          <h3 class="md-title" style="flex:1; margin-left:10px;">
            <p v-if="pko.pko_status==0" style="text-align: left; font-weight:bold;">REGISTERED</p>
            <p v-if="pko.pko_status==1" style="text-align: left; font-weight:bold;">WAITING APPROVAL</p>
            <p v-if="pko.pko_status==2" style="text-align: left; font-weight:bold;">REJECTED</p>
            <p v-if="pko.pko_status==3" style="text-align: left; font-weight:bold;">ACTIVE</p>
            <p v-if="pko.pko_status==4" style="text-align: left; font-weight:bold;">PAYMENT COMPLETED</p>
            <p v-if="pko.pko_status==5" style="text-align: left; font-weight:bold;">TERMINATED BY PAYMENT</p>
            <p v-if="pko.pko_status==6" style="text-align: left; font-weight:bold;">CHANGE TO OWNERSHIP</p>
          </h3>
        </div>
        <div style="width:50%; ">
          <div class="md-toolbar-section-end">
            <md-dialog  class="z-index "  :md-active.sync="active">
              <md-dialog-title>
                History Status
              <md-button style="float:right;" class="md-dense md-round md-icon-button" @click="active = false">
                <md-icon>close</md-icon>
              </md-button>

            </md-dialog-title>
              <md-card class="md-content1 md-scrollbar">
                <md-card-content>
                  <md-table>
                    <md-table-row>
                        <md-table-head ><b>Change</b></md-table-head>
                        <md-table-head ><b>By</b></md-table-head>
                        <md-table-head ><b>Action</b></md-table-head>
                        <md-table-head ><b>Status</b></md-table-head>
                    </md-table-row>
                    <md-table-row v-for="(item, index) in pko.pko_history_status" :key="index"> 
                        <md-table-cell >{{item.updated_at}}</md-table-cell>
                        <md-table-cell >{{item.name_by}}</md-table-cell>
                        <md-table-cell >
                          <span v-if="item.status_action==1">Request Approval</span>
                          <span v-if="item.status_action==2">Approve</span>
                          <span v-if="item.status_action==3">Reject</span>
                          <span v-if="item.status_action==4">Payment Complete</span>
                          <span v-if="item.status_action==5">Terminated By Payment</span>
                          <span v-if="item.status_action==6">Change to Ownership</span>
                        </md-table-cell>
                        <md-table-cell >
                          <span v-if="item.status==0">Registered</span>
                          <span v-if="item.status==1">Waiting Approval</span>
                          <span v-if="item.status==2">Reject</span>
                          <span v-if="item.status==3">Active</span>
                          <span v-if="item.status==4">Payment Completed</span>
                          <span v-if="item.status==5">Terminate by Payment</span>
                          <span v-if="item.status==6">Change to Ownership</span>
                        </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </md-dialog>

            <md-button class="nonprint; color md-dense" @click="active = true">History Status</md-button>
 
            <md-menu  md-direction="bottom-start">
              <md-button v-if="pko.pko_status!=3 && pko.pko_status!=4 && pko.pko_status!=5 && pko.pko_status!=6 || pko.pko_status == 3 && check_object_value(me.role_name,'name',['Admin','Terminate PKO'])" class="nonprint; md-dense color" md-menu-trigger>Change Status</md-button>
              <md-menu-content class="z-index">
                <md-menu-item v-if="(pko.pko_status==0 || pko.pko_status==2) && role.requester" class="noprint" @click="updateStatusConfirmation(1,'Request Approval')">Request Approval</md-menu-item>
                <md-menu-item v-if="pko.pko_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation(3, 'Approve')">Approve</md-menu-item>
                <md-menu-item v-if="pko.pko_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation(2,'Reject', true)">Reject</md-menu-item>
                <md-menu-item
                  v-if="pko.pko_status == 3 && check_object_value(me.role_name,'name',['Admin','Terminate PKO'])"
                  class="noprint"
                  @click="updateStatusConfirmation(5, 'Terminate by Payment', true)"
                  >Terminate by Payment</md-menu-item
                >
              </md-menu-content>
            </md-menu>

            <md-button class="nonprint; md-icon-button color md-dense" @click="closeDetail()"><md-icon>close</md-icon></md-button>
          </div>
        </div>
      </md-toolbar> -->
      
      <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top:20px;">
        <md-card>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head><b>PKO No</b></md-table-head>
                <md-table-head><b>Pool</b></md-table-head>
                <md-table-head><b>Start Date</b></md-table-head>
                <md-table-head><b>Payment Plan</b></md-table-head>
                <md-table-head><b>Initial Total Payable</b></md-table-head>
                <md-table-head v-if="pko.pko_status >= 3"><b>Estimate End Date</b></md-table-head>
                <md-table-head v-if="pko.pko_status >= 3"><b>Paid Amount</b></md-table-head>
                <md-table-head v-if="pko.pko_status >= 3"><b>Remaining Amount</b></md-table-head>
                <md-table-head v-if="pko.pko_status >= 3"><b>Approved By</b></md-table-head>
                <md-table-head ><b>Remarks</b></md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell>{{ pko.pko_no }}</md-table-cell>
                <md-table-cell>{{pko.pko_pool?pko.pko_pool.pool_name:""}}</md-table-cell>
                <md-table-cell >{{ pko.pko_start_date }}</md-table-cell>
                <md-table-cell>{{ pko.pko_payment_plant.payment_plan_name}}</md-table-cell>
                <md-table-cell><span style="float:left">Rp.</span>{{ formatPrice(pko.pko_total_payable)}}</md-table-cell>
                <md-table-cell v-if="pko.pko_status >= 3">{{ pko.pko_end_date }}</md-table-cell>
                <md-table-cell v-if="pko.pko_status >= 3"><span style="float:left">Rp.</span>{{formatPrice( pko.pko_paid_amount)}}</md-table-cell>
                <md-table-cell v-if="pko.pko_status >= 3"><span style="float:left">Rp.</span>{{formatPrice(pko.pko_remaining_amount)}}</md-table-cell>
                <md-table-cell v-if="pko.pko_status >= 3">
                  <span>{{ pko.pko_history_status.filter(data => data.status == 3)[pko.pko_history_status.filter(data => data.status == 3).length - 1].name_by}}</span></md-table-cell>
                <md-table-cell>{{ pko.pko_remark}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50 md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text">
          <h4 class="title">Driver</h4>
          </div>
        </md-card-header>
          <md-card-content>
          <md-table>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Name</md-table-cell>
              <md-table-cell>{{ pko.pko_driver.driver_name }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">KIP No</md-table-cell>
              <md-table-cell>{{ pko.pko_driver.driver_no }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Gender/Religion</md-table-cell>
              <md-table-cell>
                <span v-if="pko.pko_driver.driver_gender == 0">Pria</span>
                <span v-if="pko.pko_driver.driver_gender == 1">Wanita</span>
                /
                <span v-if="pko.pko_driver.driver_religion == 1">Islam</span>
              <span v-if="pko.pko_driver.driver_religion == 2">Kristen</span>
              <span v-if="pko.pko_driver.driver_religion == 3">Katolik</span>
              <span v-if="pko.pko_driver.driver_religion == 4">Budha</span>
              <span v-if="pko.pko_driver.driver_religion == 5">Hindu</span>
              <span v-if="pko.pko_driver.driver_religion == 6">Konghucu</span>
              <span v-if="pko.pko_driver.driver_religion == 7">Lainnya</span>
                </md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Place/Date of Birth</md-table-cell>
              <md-table-cell ><span v-if="pko.pko_driver.place_of_birth">{{ pko.pko_driver.place_of_birth.city_name+"/"+pko.pko_driver.driver_date_of_birth }}</span></md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Address</md-table-cell>
              <md-table-cell>{{ pko.pko_driver.driver_address }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Phone</md-table-cell>
              <md-table-cell>{{ pko.pko_driver.driver_phone_no}}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell style="font-weight:bold;">VA BCA</md-table-cell>
                <md-table-cell>{{ pko.pko_driver.bca_va}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">VA Duitku</md-table-cell>
                <md-table-cell>{{ pko.pko_driver.duitku_va}}</md-table-cell>
              </md-table-row>
            <md-table-row >
              <md-table-cell style="font-weight:bold;">License No/Expire</md-table-cell>
              <md-table-cell>{{ pko.pko_driver.license[0].driver_license_no+"/"+pko.pko_driver.license[0].driver_license_expire_date }}</md-table-cell>
            </md-table-row>
          </md-table>
          </md-card-content>
          </md-card>


      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50 md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text">
          <h4 class="title">Vehicle</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Vehicle No</md-table-cell>
              <md-table-cell v-if="pko.pko_vehicle">{{ pko.pko_vehicle.vehicle_door_no }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Plate No</md-table-cell>
              <md-table-cell v-if="pko.pko_vehicle">{{ pko.pko_vehicle.vehicle_plate_no }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Esheed</md-table-cell>
              <md-table-cell>
                {{ pko.pko_vehicle.pool.pool_name }}
              </md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Vehicle Model/Body Color</md-table-cell>
              <md-table-cell>
                <span >{{ pko.pko_vehicle.vehicle_types.vehicle_model }}</span>
                /
                <span v-if="pko.pko_vehicle.vehicle_body_color == 0">Putih</span>
                <span v-if="pko.pko_vehicle.vehicle_body_color == 1">Putih Kuning</span>
                <span v-if="pko.pko_vehicle.vehicle_body_color == 2">Putih Metalik</span>
                <span v-if="pko.pko_vehicle.vehicle_body_color == 3">Hitam</span>
                <span v-if="pko.pko_vehicle.vehicle_body_color == 4">Hitam Metalik</span>
                <span v-if="pko.pko_vehicle.vehicle_body_color == 5">Silver</span>
                <span v-if="pko.pko_vehicle.vehicle_body_color == 6">Silver Metalik</span>
                  <span v-if="pko.pko_vehicle.vehicle_body_color == 7">Abu Abu </span>
                  <span v-if="pko.pko_vehicle.vehicle_body_color == 8">Abu Abu Metalik</span>
                  <span v-if="pko.pko_vehicle.vehicle_body_color == 9">N/A</span>
              </md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Engine No</md-table-cell>
              <md-table-cell>{{ pko.pko_vehicle.vehicle_engine_no }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Production Year/Plate Color</md-table-cell>
              <md-table-cell>
                <span >{{ pko.pko_vehicle.vehicle_production_year }}</span>
                /
                <span v-if="pko.pko_vehicle.vehicle_plate_color == 0">Kuning</span>
                <span v-if="pko.pko_vehicle.vehicle_plate_color == 1">Hitam</span>
              </md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell style="font-weight:bold;">Registration Name/Chassis No</md-table-cell>
              <md-table-cell>{{ pko.pko_vehicle.vehicle_registration_year+"/"+pko.pko_vehicle.vehicle_chassis_no }}</md-table-cell>
            </md-table-row>
          </md-table>
          </md-card-content>
          </md-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 md-small-size-100">
        <md-card v-if="pko.pko_status >= 3">
          <md-card-header class="md-card-header-text md-card-header-primary" >
            <div class="card-text">
            <h4 class="title">List SPJ</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <v-app  class="md-layout-item md-size-100">
              <v-data-table 
                mobile-breakpoint
                :headers="headers"
                :items="pko_spj"
                
                :loading="loadTable"
                loading-text="Loading... Please wait"
                ref="vTable"
                fixed-header
                :options.sync="options"
                :server-items-length="totalDataTable"
                :page="page"
                :pageCount="numberOfPages"
                single-expand
                show-expand
                :footer-props="{'items-per-page-options':[15, 25, 50]}"
              >

              <!-- <template v-slot:[`header.spj_business_unit`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionBusinessUnit"
                  :label="header.text"
                  v-model="valueBusinessUnit"
                  @change="getList"
                  item-text="business_unit_name"
                  item-value="id"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template> -->

              <!-- <template v-slot:[`header.spj_status`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionStatus"
                  :label="header.text"
                  v-model="valueStatus"
                  @change="getListSpj"
                  item-text="text"
                  item-value="value"
                        
                  class="ma-2 v-menu__content"
                  hide-details
                >
                </v-select>
              </template> -->

              <!-- <template v-slot:[`item.spj_business_unit`]="{ item }">
                {{ item.spj_pko_data.vehicle.vehicle_business_unit.business_unit_name }}
                </template> -->

                <template v-slot:[`item.pko_no`]="{ item }">
                {{ item.spj_pko_data.pko_no }}
                </template>
                <template v-slot:[`item.spj_weekly_installment`]="{ item }">
                  <span style="float:left;">Rp.</span>
                  <span style="float:right;">{{ formatPrice(item.spj_weekly_installment) }}</span>
                </template>

                <template v-slot:[`item.spj_penalty`]="{ item }">
                  <span style="float:left;">Rp.</span>
                  <span style="float:right;">{{ formatPrice(item.spj_penalty) }}</span>
                </template>

                <template v-slot:[`item.payment_amount`]="{ item }">
                  <span style="float:left;">Rp.</span>
                  <span style="float:right;">{{ formatPrice(item.payment_amount) }}</span>
                </template>
                <template v-slot:[`item.spj_door_no`]="{ item }">
                {{ item.spj_pko_data.vehicle?item.spj_pko_data.vehicle.vehicle_door_no:null }}
                </template>
                <template v-slot:[`item.spj_kip_no`]="{ item }">
                {{ item.spj_pko_data.vehicle?item.spj_pko_data.driver.driver_no:null }}
                </template>
                <template v-slot:[`item.spj_driver_name`]="{ item }">
                {{ item.spj_pko_data.driver.driver_name }}
                </template>
                <template v-slot:[`item.spj_total_payable`]="{ item }">
                  <span style="float:left;">Rp.</span>
                  <span style="float:right;">{{ formatPrice(item.spj_weekly_installment + item.spj_penalty) }}</span>
                </template>
                <template v-slot:[`item.spj_status`]="{ item }">
                  <div  v-if="item.spj_current_status">
                    
                  <span v-if="item.spj_current_status.status==0">Registered</span>
                  <span v-if="item.spj_current_status.status==1">Partially Paid</span>
                  <span v-if="item.spj_current_status.status==2">Paid</span>
                              <span v-if="item.spj_current_status.status == 3">Unpaid</span>
                              <span v-if="item.spj_current_status.status == 4">Active</span>
                  </div>
                </template>

                <template  v-slot:expanded-item="{ headers, item }">
                <td class="pa-5" :colspan="headers.length">
                <!-- Faktur are closed: -->
                  <md-table class="ma-5">
                    <md-table-row >
                      <md-table-head style="text-align: center;"><b>No</b></md-table-head>
                      <md-table-head style="text-align: center;"><b>Payment Date</b></md-table-head>
                      <md-table-head style="text-align: center;"><b>Payment Method</b></md-table-head>
                      <md-table-head style="text-align: center;"><b>Amount</b></md-table-head>
                      <md-table-head style="text-align: center;"><b>Status</b></md-table-head>
                    </md-table-row>
                    <md-table-row  v-for="(items, index)  in item.payment_history" :key="index">
                      <md-table-cell style="text-align: center;">{{ index+1 }}</md-table-cell>
                      <md-table-cell style="text-align: center;">{{ items.payment_at }}</md-table-cell>
                      <md-table-cell style="text-align: center;">
                        <span v-if="items.payment_method==1">Cash</span>
                        <span v-if="items.payment_method==2">Transfer</span>
                        <span v-if="items.payment_method==3">Debit</span>
                        <span v-if="items.payment_method == 4">Virtual Account</span>
                      </md-table-cell>
                      <md-table-cell style="text-align: center;">
                        <span style="float:left;">Rp.</span>
                        <span style="float:right;">{{ formatPrice( items.payment_receive_amount) }}</span>
                      </md-table-cell>
                      <md-table-cell style="text-align: center;">Success</md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell colspan="4" style="font-weight:bold;">Total Paid Amount</md-table-cell>
                      <md-table-cell style="text-align: center;">
                        <span style="float:left;">Rp.</span>
                        <span style="float:right;">{{ formatPrice(item.payment_amount) }}</span>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </td>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <md-button v-if="((me.role['FmsSpjs'] && me.role['FmsSpjs'].update ==1) || role.update) && (item.spj_current_status.status==0 || item.spj_current_status.status==1 || item.spj_current_status.status==3 || item.spj_current_status.status==4)" class="md-icon-button md-dense md-info" @click="openEditSpj(item.id)">
                  <md-icon>edit</md-icon>
                </md-button>
                
                  <!-- <v-menu  offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item  v-if="role.update && item.spj_current_status.status!=2" v-on:click="openEditSpj(item.id)" >
                      <v-list-item-title x-small >Edit Spj</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu> -->
              </template>

              
              <!-- <template v-slot:[`item.actions`]="{ item }">
                
                  <v-menu  offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item  @click="modalOpenEditFormCity(item.id)">
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item  @click="deleteConfirmation(item.id)">
                      <v-list-item-title >Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template> -->
              
              
              </v-data-table>
            </v-app>
          </md-card-content>
        </md-card>
      </div>


      
          
      <div v-bind:style="{ display: not_found}">
        <center  v-if="pko ||pko == null">
          <h1>Not Found!</h1>
          <p>
            <a href="" @click="backToList()">Go to List?</a>
          </p>
        </center>
      </div>
    </div>
    <modal ref="modalEditSpj" class=" coba">
        <template v-slot:header>
          <div>
            <h3>Edit SPJ</h3> 
          </div>
          <md-button class="md-dense md-round md-icon-button" @click="modalCloseEditSpj()"><md-icon>close</md-icon></md-button>
        </template>
        
        <template v-slot:body>
          <edit-spj :data_id="$refs.modalEditSpj.data"/>
        </template>
      </modal>
  </div>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import EditSpj from "@/pages/Dashboard/Fms/Pko/Modal/EditSpj.vue";
import { Modal } from "@/components";
import Swal from 'sweetalert2';
import vuetify from '@/plugins/vuetify'

// import InfoCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/InfoCard.vue";
// import ClientCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ClientCard.vue";
// import VehicleCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/VehicleCard.vue";
// import ServiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ServiceCard.vue";
// import PartCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/PartCard.vue";
import Vue from "vue";
export default {
  name: "detail-service-estimates",

  // props: {
  //   pko: Object,
  // },
  vuetify,
  computed: {
  headers() {
    const headers =[
      // { text: "Action", value: "actions", align: "start", sortable: false },
      { text: "", value: "data-table-expand" },
      { text: "Spj No", value: "spj_no" },
      { text: "Weekly", value: "spj_weekly_installment", width:'150' },
      { text: "Penalty", value: "spj_penalty", width:'150' },
      { text: "Total Payable", value: "spj_total_payable", sortable: false, width:'150' },
      { text: "Paid Amount", value: "payment_amount", sortable: false, width:'150' },
      { text: "Status", value: "spj_status", sortable: false },
      { text: "Start Date", value: "spj_start_date" , width:'150'},
      { text: "Due Date", value: "spj_due_date", width:'150' },
      { text: "Remark", value: "spj_remarks" },
    ]
    console.log(this.role)
    if((this.me.role['FmsSpjs'] && this.me.role['FmsSpjs'].update ==1) || this.role.update) {
      headers.unshift({
         text: "Action", value: "actions", align: "start", sortable: false ,
      })
    }

    return headers
  }
},
props: {
    data_id: null,
    },
watch: {
    options: {
      
      handler() {
        console.log("asdsdsdsds");
        if( !this.mounted){
          this.getListSpj();
        }
      },
    },
    deep: true,
  },
  components: {
    "edit-spj": EditSpj, Modal
    // ValidationError,
    // FormWizard,
    // TabContent,
    // "info-card": InfoCard,
    // "client-card": ClientCard,
    // "vehicle-card": VehicleCard,
    // "service-card": ServiceCard,
    // "part-card": PartCard,
  },

  mixins: [formMixin],

  data: () => ({
    not_found: 'none',
    role:"",
    pko: null,
    showDialog:false,
    active: false,
    totalPaidAmount: 0,
    me : null,
    pko_spj: [],

    loadTable: false,
    page: 1,
    options: {},
    totalDataTable: 0,
    numberOfPages: 0,
    valueStatus:'',
    optionStatus:[ 
          { text: 'All', value: '' },
          { text: 'Paid', value: '2' },
          { text: 'Partially Paid', value: '1'},
          { text: 'Registered', value: '0'},
      { text: "Unpaid", value: "3" },
      { text: "Active", value: "4" }],

  }),
  async mounted() {
    // this.onMounted()
    // this.getListSpj();
    this.mounted = false

    },
  async created() {
    //ambil list role permission user
    this.me = await this.$store.getters["profile/me"]
      this.role =  await this.$store.getters["role_permission/route_filter"]
      // console.log(this.role)
    this.getPkoData();
  },

  methods: {
    //fungsi yang berjalan saat page pertamakali dibuka
    async getPkoData(){
      
      //ambil data se sesuai dengan id yang ikut juga dikirim melalui route
      await this.$store.dispatch("fms_pko/get", this.data_id.id)
      this.pko = await this.$store.getters["fms_pko/pko"]
      console.log( this.pko)
       //check apakah data dari api ada
        if(!this.pko){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }
      //console.log(await this.$store.getters["fms_pko/pko"])
      //check apakah data yang dikirim dari server ada
      
        //set var sesuai dengan data yang dikirim dari server
      //  if(this.pko.pko_status <= 3)
      //   this.getListSpj()

      //   var query = {"filter": {spj_pko_id:this.pko.id}}
      //  await this.$store.dispatch("fms_spj_black_plate/list",query);
      //  this.pko_spj = await this.$store.getters["fms_spj_black_plate/list"];
      //  console.log(this.pko_spj)
      //  this.totalPaidAmount = this.pko.pko_spj.reduce(function(sum, current) {
      //     return sum + current.payment_amount;
      //   }, 0);
        
    },

    async closeDetail(){
      this.$parent.$parent.modalCloseDetail();
    },

    async getListSpj() {
      

      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      let itemsPerPageNumber = itemsPerPage;
      
     var query = {"page":{number:pageNumber,size:itemsPerPageNumber}}
      query.filter = {spj_pko_id:this.data_id.id}
      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort
      }
      else{
         query.sort = "spj_sequence_no"
      }

      if (this.searchValue && this.searchCategory) {
           if (query.filter) {
              Object.assign(query.filter, { [this.searchCategory]: this.searchValue});
            } else {
             
        query.filter = { [this.searchCategory]: this.searchValue };
            }
      }

      if(this.valueStatus!=''){
        if(query.filter){
          Object.assign(query.filter, {spj_status:this.valueStatus});
        }
        else{
          query.filter = {spj_status:this.valueStatus}
        }
      }

    
     console.log(query);
      await this.$store.dispatch("fms_spj/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.pko_spj = await this.$store.getters["fms_spj/list"];
        var pageMeta  = await this.$store.getters["fms_spj/page"];
      // }
      // else{
      //   this.table = []
      // }

      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
    },

    openEditSpj(id){
      this.$refs.modalEditSpj.openModal({id:id})
    },

    modalCloseEditSpj(){
      this.getListSpj()
      this.$refs.modalEditSpj.closeModal()
      
    },


    

    // fungsi currency number
    formatPrice(value) {
      let val = (value/1).toFixed().replace('.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    // direct ke edit form
    // editPko(id) {
    //   //pindah ke page edit, id juga ikut dikirim melalui route
    //   this.$router.push({ name: 'Edit PKO', params: {pko: id, id } })
    // },
    
    

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.deleterPko(id)
        }
      });
    },
    
    // fungsi delete data
    async deleterPko(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("fms_pko/destroy", id)
        //panggil alert succes
        await this.$store.dispatch("alerts/success", "User data delete successfully.")
        //kembali ke page list
        this.$router.replace({ name: 'List PKO'})
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }
    },

    // validasi perubahan status
    updateStatusConfirmation(status,status_text){
      if(status == 5){
        Swal.fire({

          title: status_text,
          text: 'Are you sure want to change the status to '+status_text+'?',
          html:
              '<fieldset><legend>Terminate Date</legend>'+
              '<div><input type="date" id="dateTerminate" ><div>' +
              '<div class="swal2-validation-message" id="swal2-validation-message-date-terminate" style="display: none;">You need to choose date!</div>'+
              '</fieldset>'+
              '<fieldset><legend>Vehicle return status:</legend>'+
              '<div><input style="margin: .4rem;" type="radio" id="statusVehicle1" name="statusVehicle" value="return"> <label for="statusVehicle1">Returned</label>' +
              '<input style="margin: .4rem;" type="radio" id="statusVehicle2" name="statusVehicle" value="repo"> <label for="statusVehicle2">Repo</label><div>' +
              '<div class="swal2-validation-message" id="swal2-validation-message-status-vehicle" style="display: none;">You need to choose something!</div>'+
                '</fieldset>'+
              '<fieldset><legend>Date the vehicle was returned/repo</legend>'+
              '<div><input type="date" id="dateVehicle" ><div>' +
              '<div class="swal2-validation-message" id="swal2-validation-message-date-vehicle" style="display: none;">You need to choose date!</div>'+
              '</fieldset>'+
              '<fieldset><legend>Vehicle Key:</legend>'+
                '<div><input style="margin: .4rem;" type="radio" id="itemVehicleKey1" name="itemVehicleKey" value=1> <label for="itemVehicleKey1">Avaible</label>' +
              '<input style="margin: .4rem;" type="radio" id="itemVehicleKey2" name="itemVehicleKey" value=2> <label for="itemVehicleKey2">Missing</label><div>' +
              '<div class="swal2-validation-message" id="swal2-validation-message-item-key-vehicle" style="display: none;">You need to choose something!</div>'+
              '</fieldset>'+
              '<fieldset><legend>Vehicle STNK:</legend>'+
                '<div><input style="margin: .4rem;" type="radio" id="itemVehicleStnk1" name="itemVehicleStnk" value=1> <label for="itemVehicleStnk1">No Issue</label>' +
                '<input style="margin: .4rem;" type="radio" id="itemVehicleStnk2" name="itemVehicleStnk" value=2> <label for="itemVehicleStnk2">Missing</label><div>' +
                '<input style="margin: .4rem;" type="radio" id="itemVehicleStnk3" name="itemVehicleStnk" value=3> <label for="itemVehicleStnk3">Got Fined</label><div>' +
                '<input style="margin: .4rem;" type="radio" id="itemVehicleStnk4" name="itemVehicleStnk" value=4> <label for="itemVehicleStnk4">STNK Renewal</label><div>' +
              '<div class="swal2-validation-message" id="swal2-validation-message-item-stnk-vehicle" style="display: none;">You need to choose something!</div>'+
              '</fieldset>',
              
            focusConfirm: false,
            allowOutsideClick: false,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Change',
            cancelButtonText: 'Cancel',
            buttonsStyling: true,
            preConfirm: () => {
              if(document.getElementById('dateTerminate').value == "" || document.getElementById('dateVehicle').value == "" || document.querySelector("input[name=statusVehicle]:checked") == null){
                if(document.querySelector("input[name=statusVehicle]:checked") == null){
                  document.getElementById("swal2-validation-message-status-vehicle").style.display = "flex"; 
                }
                else{
                  document.getElementById("swal2-validation-message-status-vehicle").style.display = "none"; 
                }
                if(document.querySelector("input[name=itemVehicleKey]:checked") == null){
                  document.getElementById("swal2-validation-message-item-key-vehicle").style.display = "flex"; 
                }
                else{
                  document.getElementById("swal2-validation-message-item-key-vehicle").style.display = "none"; 
                }
                if(document.querySelector("input[name=itemVehicleStnk]:checked") == null){
                  document.getElementById("swal2-validation-message-item-stnk-vehicle").style.display = "flex"; 
                }
                else{
                  document.getElementById("swal2-validation-message-item-stnk-vehicle").style.display = "none"; 
                }
                
                if(document.getElementById('dateVehicle').value == ""){
                  document.getElementById("swal2-validation-message-date-vehicle").style.display = "flex"; 
                }
                else{
                  document.getElementById("swal2-validation-message-date-vehicle").style.display = "none"; 
                }

                if(document.getElementById('dateTerminate').value == ""){
                  document.getElementById("swal2-validation-message-date-terminate").style.display = "flex"; 
                }
                else{
                  document.getElementById("swal2-validation-message-date-terminate").style.display = "none"; 
                }
               
                return false
              }
              return {dateTerminate:document.getElementById('dateTerminate').value !=""? document.getElementById('dateTerminate').value : null,
                      dateVehicle:document.getElementById('dateVehicle').value !=""? document.getElementById('dateVehicle').value : null,
                      statusVehicle: document.querySelector("input[name=statusVehicle]:checked") ? document.querySelector("input[name=statusVehicle]:checked").value:null,
                      keyVehicle:document.querySelector('input[name=itemVehicleKey]:checked') ? document.querySelector('input[name=itemVehicleKey]:checked').value : 0,
                      stnkVehicle:document.querySelector('input[name=itemVehicleStnk]:checked') ? document.querySelector('input[name=itemVehicleStnk]:checked').value : 0
              }
            }
          }).then((result) => {
            console.log(result.value);
          if (result.value){
            this.updateStatus(status,result.value.dateTerminate,result.value.dateVehicle,result.value.statusVehicle,result.value.keyVehicle,result.value.stnkVehicle)
          }
        });
      }
      else{
          Swal.fire({
          title: 'Are you sure want to change the status to '+status_text+'?',
          text: 'The data will Saved!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, change it!',
          cancelButtonText: 'No, cancel!',
          buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateStatus(status)
          }
        });
      }
    },
    
    // fungsi update status
    async updateStatus(status,dateTerminate = null, dateVehicle = null, statusVehicle = null, keyVehicle = null, stnkVehicle = null) {
      const data = {
          type: "fms_pkos",
          id:this.pko.id,
          status: status
        }

        if(status == 5){
          data.return_terminate_date = dateTerminate;
          data.return_vehicle_date = dateVehicle;
          data.return_status_vehicle = statusVehicle;
          data.return_key_vehicle = keyVehicle;
          data.return_stnk_vehicle = stnkVehicle;
        }

        //console.log(data)
        try {
          //kirim data keserver
        await this.$store.dispatch("fms_pko/update", data);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Status Successfully update."
        );
        //jalankan fungsi kembali kelist
           this.getPkoData()
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
      }

      },
    
    // direct ke list view table
    async backToList(){
      await this.$router.replace({name: 'List PKO'})
    },
    check_object_value(array, key, value) {
        //return array.some(object => object[key] === value);
        return array.some(object => value.includes(object[key]));
        },
      
  }
};
</script>
<style lang="scss" scoped>

.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 520 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 510 !important;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 510 !important;
  }

.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
@media print{
   .print{
       visibility: visible;
       zoom: 80%;
      margin: none;
   }
   .noprint{
     display: none;
   }
   /* content {transform: scale(.5);}
    .md-card {page-break-inside: avoid;} */

  
}

/* .md-layout{
  background-color: white;
} */

.md-card{
  box-shadow: 0 3px 5px 1px rgb(0 0 0/ 14%);
 
}

.z-index{
  z-index: 9999 !important;
}



.coba{
  width:600px !important;
  height: 350px !important;
  margin: auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}

.md-content1 {
    max-width: 800px;
    max-height: 500px;
    overflow: auto;
  }

.color{
  background-color: #1976d2 !important;
}
</style>